<script setup lang="ts">
// Mock of the real chat screen; messages arrive one by one while it is on screen.
import { useElementVisibility, useIntervalFn } from '@vueuse/core'

const messages = [
  { mine: false, text: 'Привет, Варвара! Посмотрели твоё видео — очень понравилось 🙌' },
  { mine: false, text: 'Сможешь выйти на стажировку в субботу к 8:00?' },
  { mine: true, text: 'Здравствуйте! Да, конечно, буду ☕️' },
  { mine: false, text: 'Отлично! Ждём на Ленина, 12. Фартук выдадим 😊' },
]

const root = useTemplateRef<HTMLElement>('root')
const visible = useElementVisibility(root)
const shown = ref(1)
const typing = computed(() => shown.value < messages.length)

const { pause, resume } = useIntervalFn(() => {
  shown.value = shown.value >= messages.length + 2 ? 1 : shown.value + 1
}, 1600, { immediate: false })

watch(visible, value => value ? resume() : pause())
</script>

<template>
  <div ref="root" class="flex size-full flex-col bg-background text-[15px]">
    <div class="flex items-center gap-3 border-b px-4 pb-3 pt-12">
      <Icon name="tabler:chevron-left" class="size-5 text-muted-foreground" />
      <span class="relative flex size-9 items-center justify-center rounded-full bg-amber-500 text-sm font-bold text-white">
        З
        <span class="absolute bottom-0 right-0 size-2.5 rounded-full border-2 border-background bg-status-online" />
      </span>
      <span class="min-w-0 flex-1">
        <span class="block truncate text-[17px] font-semibold">Кофейня «Зерно»</span>
        <span class="block text-xs text-muted-foreground">{{ typing ? 'печатает…' : 'в сети' }}</span>
      </span>
    </div>
    <TransitionGroup
      tag="div"
      class="flex flex-1 flex-col gap-2 overflow-hidden p-3"
      enter-from-class="translate-y-3 opacity-0"
      enter-active-class="transition duration-300"
    >
      <span key="badge" class="self-center rounded-full bg-muted px-3 py-1 text-xs text-muted-foreground">
        Отклик на вакансию «Бариста»
      </span>
      <p
        v-for="message in messages.slice(0, Math.min(shown, messages.length))"
        :key="message.text"
        class="max-w-[82%] rounded-2xl px-4 py-2.5 leading-snug"
        :class="message.mine ? 'self-end rounded-tr-md border border-border bg-background' : 'self-start rounded-tl-md bg-muted'"
      >
        {{ message.text }}
      </p>
      <span v-if="typing" key="typing" class="flex gap-1 self-start rounded-2xl rounded-tl-md bg-muted px-3 py-3">
        <span class="size-1.5 animate-bounce rounded-full bg-muted-foreground" />
        <span class="size-1.5 animate-bounce rounded-full bg-muted-foreground [animation-delay:150ms]" />
        <span class="size-1.5 animate-bounce rounded-full bg-muted-foreground [animation-delay:300ms]" />
      </span>
    </TransitionGroup>
    <div class="flex items-center gap-2 px-3 pb-6">
      <span class="flex h-11 flex-1 items-center rounded-xl border border-input px-3 text-muted-foreground">Сообщение...</span>
      <span class="flex size-10 items-center justify-center rounded-full bg-primary text-primary-foreground">
        <Icon name="tabler:send" class="size-4" />
      </span>
    </div>
  </div>
</template>
